(function () {
  'use strict';

  var root = document.documentElement;
  var DURATION = 180;
  var navigationTimer = null;
  var isNavigating = false;

  var ALLOWED_PATHS = [
    /^\/$/,
    /^\/collections(?:\/|$)/,
    /^\/products(?:\/|$)/,
    /^\/pages(?:\/|$)/,
    /^\/blogs(?:\/|$)/,
    /^\/policies(?:\/|$)/,
    /^\/search(?:\/|$)/
  ];

  var EXCLUDED_PATHS = [
    /^\/cart(?:\/|$)/,
    /^\/checkout(?:\/|$)/,
    /^\/account(?:\/|$)/,
    /^\/challenge(?:\/|$)/,
    /^\/tools(?:\/|$)/,
    /^\/apps(?:\/|$)/,
    /^\/admin(?:\/|$)/
  ];

  var EXCLUDED_ANCESTORS = [
    '[data-no-an-transition]',
    '[data-no-swup]',
    '[data-shopify-payment-button]',
    '.shopify-payment-button',
    'localization-form',
    'predictive-search',
    'modal-dialog',
    'quick-add-modal'
  ].join(',');

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function matchesAny(pathname, patterns) {
    return patterns.some(function (pattern) {
      return pattern.test(pathname);
    });
  }

  function isSafeNavigation(link, event) {
    if (!link || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target.toLowerCase() !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.closest(EXCLUDED_ANCESTORS)) return false;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(rawHref)) return false;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return false;
    if (matchesAny(url.pathname, EXCLUDED_PATHS)) return false;
    if (!matchesAny(url.pathname, ALLOWED_PATHS)) return false;

    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }

    return url.href !== window.location.href;
  }

  function resetTransition() {
    if (navigationTimer) {
      window.clearTimeout(navigationTimer);
      navigationTimer = null;
    }

    isNavigating = false;
    root.classList.remove('an-transition-active', 'an-transition-leaving');
  }

  function navigate(url) {
    if (isNavigating) return;
    isNavigating = true;
    root.classList.add('an-transition-active');

    navigationTimer = window.setTimeout(function () {
      root.classList.add('an-transition-leaving');
      window.location.assign(url);
    }, prefersReducedMotion() ? 0 : DURATION);
  }

  function handleClick(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!isSafeNavigation(link, event)) return;

    event.preventDefault();
    navigate(link.href);
  }

  function init() {
    if (isDesignMode()) return;

    document.addEventListener('click', handleClick, false);
    window.addEventListener('pageshow', resetTransition);
    window.addEventListener('pagehide', function () {
      if (isNavigating) root.classList.add('an-transition-leaving');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.ANPageTransition = {
    reset: resetTransition,
    navigate: navigate
  };
})();
